import { Ref, ref } from "vue"

import { TaskStatus } from "@/types/common.type"

export type TaskState = {
  taskId: string | null
  progress: number
  status: TaskStatus
  downloadUrl: string | null
}

export const useTask = () => {
  const pollUrlTask = async (
    taskId: string,
    taskState: Ref<TaskState>,
    checkTaskFunction: (taskId: string) => Promise<any>,
    pollInterval: number = 3000
  ): Promise<string | null> => {
    if (!taskId) return null

    const poll = async (): Promise<string | null> => {
      try {
        const response = await checkTaskFunction(taskId)

        taskState.value.progress = response?.progress || 0
        taskState.value.status = response?.state || TaskStatus.PENDING

        if (response?.state === TaskStatus.SUCCESS) {
          taskState.value.downloadUrl = response?.data?.url
          return response?.data?.url || null
        } else if (response?.state === TaskStatus.FAILURE) {
          taskState.value.status = TaskStatus.FAILURE
          return null
        } else {
          // Чекаємо pollInterval і потім рекурсивно викликаємо poll
          await new Promise((resolve) => setTimeout(resolve, pollInterval))
          return poll()
        }
      } catch (error) {
        console.error("Error polling task:", error)
        taskState.value.status = TaskStatus.FAILURE
        return null
      }
    }

    return poll()
  }

  return {
    pollUrlTask
  }
}
